const PHONES = [
  { label: "0370 701 2930", href: "tel:+403707012930" },
  { label: "0750 280 911", href: "tel:+40750280911" },
];

export const CONTACT = {
  company: "ARMAT DEFENSE S.R.L.",
  phones: PHONES,
  phone: PHONES[0].label,
  phoneHref: PHONES[0].href,
  emails: ["office@armatdefense.ro", "contact@armatdefense.ro"],
  email: "contact@armatdefense.ro",
  address: "Str. Constantin Mille, Bl. 5, Sc. 3, Ap. 30, Petroșani, Jud. Hunedoara, România",
  mapsQuery: "Strada Constantin Mille, Petroșani, Hunedoara, România",
  cui: "53552260",
  regcom: "J2026005753004",
  license: "I.G.P.R. nr. 8226/T",
};

export const LEGAL_ROUTES = { privacy: "/politica-de-confidentialitate", terms: "/termeni-si-conditii", cookies: "/politica-cookie" };

export const SERVICE_KEYS = ["cctv", "alarm", "access", "fire", "time"];
export const SERVICE_IMG = {
  cctv: "/img/cctv.jpg",
  alarm: "/img/alarm.jpg",
  access: "/img/access.jpg",
  fire: "/img/fire.jpg",
  time: "/img/time.jpg",
};
export const SLOTS = ["08:00-10:00", "10:00-12:00", "12:00-14:00", "14:00-16:00", "16:00-18:00"];

const ro = {
  nav: { about: "Despre", services: "Servicii", booking: "Programare", hub: "Corporate", contact: "Contact", cta: "Programează vizita", menu: "Meniu", close: "Închide" },
  hero: {
    eyebrow: "Societate licențiată I.G.P.R. nr. 8226/T · Legea 333/2003",
    lines: ["Protecție", "Profesională", "Pentru tine."],
    sub: "Proiectăm și instalăm sisteme de securitate de înaltă calitate, adaptate nevoilor tale. Echipa noastră profesionistă asigură protecția deplină a bunurilor și persoanelor.",
    cta: "Programează o vizită gratuită",
    cta2: "Serviciile noastre",
    stats: [["24/7", "Disponibilitate"], ["100%", "Profesionalism"], ["IGPR", "Licențiați"]],
    feed: "CAM 01 · PETROȘANI",
    scroll: "Derulează",
  },
  marquee: ["Supraveghere CCTV 4K", "Alarmă anti-efracție", "Control acces", "Detecție incendiu", "Pontaj & prezență", "Licență I.G.P.R.", "Legea 333/2003", "Fără compromisuri"],
  services: {
    eyebrow: "01 — Sisteme",
    title: "Serviciile noastre",
    sub: "Oferim o gamă completă de sisteme de securitate profesionale, adaptate nevoilor specifice ale fiecărui client.",
    specs: "Specificații tehnice",
    sheet: "Fișă tehnică",
    book: "Programează instalarea",
    sectors: "Domenii",
    sheetNote: "Configurația finală, echipamentele și numărul de puncte se stabilesc după vizita tehnică la fața locului. Documentația completă a echipamentelor instalate este predată la recepția lucrării.",
    print: "Printează fișa",
    items: {
      cctv: {
        title: "Supraveghere video CCTV",
        short: "Sisteme de supraveghere",
        desc: "Instalare și întreținere sisteme CCTV de ultimă generație cu monitorizare în timp real și stocare cloud.",
        specs: [["Rezoluție", "până la 4K / 8 MP"], ["Compresie", "H.265+"], ["Vedere nocturnă", "IR / color low-light"], ["Analiză video", "detecție persoane & vehicule"], ["Acces", "aplicație mobilă, în timp real"], ["Stocare", "NVR local + cloud"]],
      },
      alarm: {
        title: "Alarmă anti-efracție",
        short: "Sisteme de alarmă",
        desc: "Instalare sisteme de alarmă anti-efracție cu notificare instantanee pe smartphone.",
        specs: [["Comunicare", "GSM / IP / Wi-Fi"], ["Senzori", "PIR, perdea, magnetici, geam spart"], ["Notificări", "push, SMS, apel"], ["Comandă", "tastatură, telecomandă, aplicație"], ["Partiții", "zonare pe etaje și zone"], ["Dispecerat", "compatibil monitorizare"]],
      },
      access: {
        title: "Control acces",
        short: "Control acces",
        desc: "Sisteme moderne de control acces cu carduri, amprentă sau recunoaștere facială pentru siguranță maximă.",
        specs: [["Identificare", "card RFID, PIN, amprentă, facial"], ["Execuție", "electromagneți, bariere, porți"], ["Jurnal", "istoric complet al accesărilor"], ["Drepturi", "pe utilizator și interval orar"], ["Interfonie", "videointerfoane IP"]],
      },
      fire: {
        title: "Detecție incendiu",
        short: "Detecție incendiu",
        desc: "Sisteme de detecție și semnalizare a incendiului, cu detectori de fum și temperatură și alertare imediată.",
        specs: [["Centrală", "convențională sau adresabilă"], ["Detectori", "fum optic, termici, multi-senzor"], ["Alertare", "sirene, flash, butoane manuale"], ["Notificare", "transmisie la distanță"], ["Conformitate", "conform normativelor în vigoare"]],
      },
      time: {
        title: "Pontaj & prezență",
        short: "Pontaj",
        desc: "Terminale de pontaj care înregistrează automat prezența angajaților, cu rapoarte clare pentru resurse umane.",
        specs: [["Identificare", "amprentă, facial, card"], ["Rapoarte", "ore lucrate, întârzieri, ore suplimentare"], ["Export", "Excel / CSV"], ["Integrare", "control acces pe aceeași ușă"], ["Conectivitate", "TCP/IP, USB"]],
      },
    },
    sectorNames: { residential: "Rezidențial", commercial: "Comercial", industrial: "Industrial" },
  },
  manifesto: "Securitatea nu este un produs, ci un proces continuu.",
  about: {
    eyebrow: "02 — Despre",
    title: "De ce să alegi Armat Defense?",
    licTitle: "Licențiați I.G.P.R.",
    lead: "ARMAT DEFENSE este o societate licențiată I.G.P.R., conform Legii 333/2003.",
    body: "Armat Defense a luat naștere din dorința de a oferi soluții de protecție care să funcționeze impecabil atunci când contează cel mai mult. Suntem o echipă tânără dedicată instalării sistemelor de securitate, ghidați de un principiu simplu: fără compromisuri! Ne dorim să devenim partenerul dumneavoastră de încredere, oferind soluții inteligente care transformă orice spațiu, fie el locuință sau sediu de firmă, într-o fortăreață tehnologizată și adaptată necesităților din prezent.",
    cards: {
      support: ["Suport 24/7", "Echipa noastră tehnică este disponibilă non-stop pentru tine."],
      pro: ["Profesionalism", "Lucrări executate curat, documentate și predate la cheie."],
      tech: ["Tehnologie avansată", "Utilizăm cele mai noi sisteme de securitate și supraveghere."],
      nocomp: ["Fără compromisuri", "De la locuințe la hale industriale — fiecare spațiu devine o fortăreață tehnologizată."],
    },
  },
  booking: {
    eyebrow: "03 — Portal client",
    title: "Programează o vizită tehnică",
    sub: "Un specialist vine la tine, vede spațiul și îți propune sistemul potrivit, împreună cu o ofertă personalizată. Gratuit și fără obligații.",
    badge: "Vizită & ofertă gratuită",
    steps: ["Sistem", "Proprietate", "Data & ora", "Contact"],
    q1: "Ce sisteme dorești să instalezi?",
    q1hint: "Poți alege mai multe.",
    q2: "Ce tip de proprietate este?",
    areaLabel: "Suprafață aproximativă",
    property: { residential: ["Rezidențial", "Casă, apartament, vilă"], commercial: ["Comercial", "Birou, magazin, HoReCa"], industrial: ["Industrial", "Hală, depozit, fabrică"] },
    areas: { lt100: "< 100 m²", "100_500": "100 – 500 m²", "500_2000": "500 – 2.000 m²", gt2000: "> 2.000 m²" },
    q3: "Când vrei să vină echipa noastră?",
    slotLabel: "Interval orar",
    q4: "Datele tale de contact",
    name: "Nume complet", phone: "Telefon", email: "Email", city: "Localitate", address: "Adresă (opțional)", notes: "Detalii suplimentare (opțional)",
    consent: "Sunt de acord ca Armat Defense să folosească aceste date pentru a mă contacta în legătură cu această cerere.",
    consentLink: "Politica de confidențialitate",
    back: "Înapoi", next: "Continuă", submit: "Trimite cererea", sending: "Se trimite…",
    summary: "Rezumat",
    errors: { services: "Alege cel puțin un sistem.", property: "Alege tipul proprietății și suprafața.", date: "Alege data și intervalul orar.", contact: "Completează corect numele, telefonul, emailul, localitatea și acordul.", server: "Cererea nu a putut fi trimisă. Încearcă din nou sau sună-ne." },
    pick: "Alege o dată",
  },
  hub: {
    eyebrow: "04 — Corporate",
    title: "Licențiați. Conformi. Aproape de tine.",
    credTitle: "Date oficiale",
    creds: [["Denumire", "ARMAT DEFENSE S.R.L."], ["Licență", "I.G.P.R. nr. 8226/T"], ["CUI", "53552260"], ["Reg. Com.", "J2026005753004"], ["Sediu", "Petroșani, jud. Hunedoara"]],
    compliance: ["Proiectare & instalare conform Legii 333/2003", "Personal tehnic atestat", "Documentație predată la recepție", "Mentenanță & service post-instalare"],
    mapTitle: "Acoperire în România",
    legend: ["Sediu central", "Zonă principală de intervenție", "Proiecte în toată țara, la cerere"],
    channels: "Canale directe",
    call: "Sună acum", write: "Scrie-ne", visit: "Sediu",
  },
  cta: { title: "Ai nevoie de protecție profesională?", sub: "Contactează-ne astăzi pentru o consultanță gratuită și o ofertă personalizată pentru nevoile tale de securitate.", btn: "Solicită ofertă", call: "Sună acum" },
  footer: { tagline: "Proiectăm și instalăm sisteme de securitate profesionale pentru protecția afacerii sau proprietății tale.", contact: "Contact", id: "Date de identificare", legal: "Legal", phone: "Telefon", email: "Email", address: "Sediu social", company: "Denumire", license: "Licență", rights: "Toate drepturile rezervate.", privacy: "Politica de confidențialitate", terms: "Termeni și condiții", cookies: "Politica de cookie-uri", contactPage: "Pagina de contact" },
  contactPage: {
    eyebrow: "Contact",
    title: "Vorbim despre securitatea ta.",
    sub: "Sună-ne, scrie-ne sau programează direct o vizită tehnică gratuită. Îți răspundem rapid, cu soluția potrivită spațiului tău.",
    phones: "Telefon", emails: "Email", address: "Sediu social", company: "Date de identificare", map: "Locație", book: "Programează o vizită tehnică", open: "Deschide în Google Maps",
  },
  legal: { updated: "Ultima actualizare", toc: "Cuprins", onlyRo: "", back: "Înapoi la site" },
  cookie: {
    title: "Respectăm confidențialitatea ta",
    text: "Folosim cookie-uri esențiale pentru funcționarea și securitatea site-ului. Cu acordul tău, putem folosi și cookie-uri non-esențiale (de performanță, analiză și ale terților, precum harta Google). Îți poți schimba oricând alegerea din subsolul site-ului.",
    link: "Politica de cookie-uri",
    accept: "Acceptă toate",
    essential: "Doar esențiale",
    settings: "Setări cookie-uri",
    mapBlocked: "Harta Google folosește cookie-uri ale terților și se afișează doar dacă accepți toate cookie-urile.",
    mapLoad: "Acceptă și afișează harta",
  },
  confirm: {
    eyebrow: "Cerere înregistrată",
    title: "Mulțumim, {name}.",
    sub: "Am primit solicitarea ta. Un specialist Armat Defense te va contacta în cel mai scurt timp pentru a confirma vizita.",
    ref: "Referință", systems: "Sisteme", property: "Proprietate", when: "Programare", city: "Localitate", status: "Status", pending: "În așteptarea confirmării",
    home: "Înapoi la site", notFound: "Nu am găsit această programare.", loading: "Se încarcă…",
  },
};

const en = {
  nav: { about: "About", services: "Services", booking: "Booking", hub: "Corporate", contact: "Contact", cta: "Book a visit", menu: "Menu", close: "Close" },
  hero: {
    eyebrow: "I.G.P.R. licensed company no. 8226/T · Law 333/2003",
    lines: ["Professional", "Protection", "For you."],
    sub: "We design and install high-quality security systems tailored to your needs. Our professional team ensures complete protection of property and people.",
    cta: "Book a free on-site visit",
    cta2: "Our services",
    stats: [["24/7", "Availability"], ["100%", "Professionalism"], ["IGPR", "Licensed"]],
    feed: "CAM 01 · PETROȘANI",
    scroll: "Scroll",
  },
  marquee: ["4K CCTV surveillance", "Intrusion alarms", "Access control", "Fire detection", "Time attendance", "I.G.P.R. licence", "Law 333/2003", "No compromise"],
  services: {
    eyebrow: "01 — Systems",
    title: "Our services",
    sub: "A complete range of professional security systems, tailored to the specific needs of every client.",
    specs: "Technical specifications",
    sheet: "Spec sheet",
    book: "Book installation",
    sectors: "Sectors",
    sheetNote: "Final configuration, equipment and number of points are defined after the on-site technical visit. Full documentation of installed equipment is handed over at project acceptance.",
    print: "Print sheet",
    items: {
      cctv: { title: "CCTV video surveillance", short: "Surveillance", desc: "Installation and maintenance of state-of-the-art CCTV systems with real-time monitoring and cloud storage.", specs: [["Resolution", "up to 4K / 8 MP"], ["Compression", "H.265+"], ["Night vision", "IR / colour low-light"], ["Video analytics", "people & vehicle detection"], ["Access", "mobile app, real time"], ["Storage", "local NVR + cloud"]] },
      alarm: { title: "Intrusion alarm", short: "Alarm systems", desc: "Installation of intrusion alarm systems with instant smartphone notifications.", specs: [["Communication", "GSM / IP / Wi-Fi"], ["Sensors", "PIR, curtain, magnetic, glass-break"], ["Notifications", "push, SMS, call"], ["Control", "keypad, remote, app"], ["Partitions", "zoning by floors and areas"], ["Monitoring", "monitoring-centre ready"]] },
      access: { title: "Access control", short: "Access control", desc: "Modern access control with cards, fingerprint or facial recognition for maximum safety.", specs: [["Identification", "RFID card, PIN, fingerprint, face"], ["Hardware", "maglocks, barriers, gates"], ["Log", "complete access history"], ["Permissions", "per user and time window"], ["Intercom", "IP video intercoms"]] },
      fire: { title: "Fire detection", short: "Fire detection", desc: "Fire detection and alarm systems with smoke and heat detectors and immediate alerting.", specs: [["Panel", "conventional or addressable"], ["Detectors", "optical smoke, heat, multi-sensor"], ["Alerting", "sounders, strobes, call points"], ["Notification", "remote transmission"], ["Compliance", "to current regulations"]] },
      time: { title: "Time & attendance", short: "Attendance", desc: "Attendance terminals that automatically record employee presence, with clear HR reports.", specs: [["Identification", "fingerprint, face, card"], ["Reports", "hours, late arrivals, overtime"], ["Export", "Excel / CSV"], ["Integration", "access control on the same door"], ["Connectivity", "TCP/IP, USB"]] },
    },
    sectorNames: { residential: "Residential", commercial: "Commercial", industrial: "Industrial" },
  },
  manifesto: "Security is not a product, but a continuous process.",
  about: {
    eyebrow: "02 — About",
    title: "Why choose Armat Defense?",
    licTitle: "I.G.P.R. licensed",
    lead: "ARMAT DEFENSE is an I.G.P.R. licensed company, in accordance with Law 333/2003.",
    body: "Armat Defense was born from the desire to deliver protection that works flawlessly when it matters most. We are a young team dedicated to installing security systems, guided by one simple principle: no compromise. We aim to become your trusted partner, delivering smart solutions that turn any space — home or headquarters — into a technology-driven fortress built for today's needs.",
    cards: {
      support: ["24/7 support", "Our technical team is available around the clock."],
      pro: ["Professionalism", "Clean, documented, turnkey installations."],
      tech: ["Advanced technology", "We use the latest security and surveillance systems."],
      nocomp: ["No compromise", "From homes to industrial halls — every space becomes a technology-driven fortress."],
    },
  },
  booking: {
    eyebrow: "03 — Client portal",
    title: "Book an on-site technical visit",
    sub: "A specialist visits your site, reviews the space and recommends the right system, with a personalised quote. Free and with no obligation.",
    badge: "Free visit & quote",
    steps: ["System", "Property", "Date & time", "Contact"],
    q1: "Which systems would you like installed?",
    q1hint: "You can choose several.",
    q2: "What type of property is it?",
    areaLabel: "Approximate area",
    property: { residential: ["Residential", "House, apartment, villa"], commercial: ["Commercial", "Office, shop, hospitality"], industrial: ["Industrial", "Hall, warehouse, plant"] },
    areas: { lt100: "< 100 m²", "100_500": "100 – 500 m²", "500_2000": "500 – 2,000 m²", gt2000: "> 2,000 m²" },
    q3: "When should our team come by?",
    slotLabel: "Time slot",
    q4: "Your contact details",
    name: "Full name", phone: "Phone", email: "Email", city: "City / town", address: "Address (optional)", notes: "Additional details (optional)",
    consent: "I agree that Armat Defense may use this data to contact me about this request.",
    consentLink: "Privacy policy",
    back: "Back", next: "Continue", submit: "Send request", sending: "Sending…",
    summary: "Summary",
    errors: { services: "Choose at least one system.", property: "Choose the property type and area.", date: "Choose a date and time slot.", contact: "Please fill in name, phone, email, city and consent correctly.", server: "The request could not be sent. Please try again or call us." },
    pick: "Pick a date",
  },
  hub: {
    eyebrow: "04 — Corporate",
    title: "Licensed. Compliant. Close to you.",
    credTitle: "Official details",
    creds: [["Company", "ARMAT DEFENSE S.R.L."], ["Licence", "I.G.P.R. no. 8226/T"], ["Tax ID (CUI)", "53552260"], ["Trade Reg.", "J2026005753004"], ["Headquarters", "Petroșani, Hunedoara county"]],
    compliance: ["Design & installation per Law 333/2003", "Certified technical staff", "Documentation handed over at acceptance", "Post-installation maintenance & service"],
    mapTitle: "Coverage across Romania",
    legend: ["Headquarters", "Primary service area", "Nationwide projects on request"],
    channels: "Direct channels",
    call: "Call now", write: "Email us", visit: "Office",
  },
  cta: { title: "Need professional protection?", sub: "Contact us today for a free consultation and a personalised quote for your security needs.", btn: "Request a quote", call: "Call now" },
  footer: { tagline: "We design and install professional security systems to protect your business or property.", contact: "Contact", id: "Company details", legal: "Legal", phone: "Phone", email: "Email", address: "Registered office", company: "Company", license: "Licence", rights: "All rights reserved.", privacy: "Privacy policy", terms: "Terms of service", cookies: "Cookie policy", contactPage: "Contact page" },
  contactPage: {
    eyebrow: "Contact",
    title: "Let's talk about your security.",
    sub: "Call us, email us or book a free on-site technical visit directly. We reply quickly, with the right solution for your space.",
    phones: "Phone", emails: "Email", address: "Registered office", company: "Company details", map: "Location", book: "Book a technical visit", open: "Open in Google Maps",
  },
  legal: { updated: "Last updated", toc: "Contents", onlyRo: "This legal document is published in Romanian, the governing language.", back: "Back to site" },
  cookie: {
    title: "We respect your privacy",
    text: "We use essential cookies to keep this site working and secure. With your consent, we may also use non-essential cookies (performance, analytics and third-party cookies such as Google Maps). You can change your choice at any time from the site footer.",
    link: "Cookie policy",
    accept: "Accept all",
    essential: "Essential only",
    settings: "Cookie settings",
    mapBlocked: "The Google map uses third-party cookies and is shown only if you accept all cookies.",
    mapLoad: "Accept & show map",
  },
  confirm: {
    eyebrow: "Request received",
    title: "Thank you, {name}.",
    sub: "We have received your request. An Armat Defense specialist will contact you shortly to confirm the visit.",
    ref: "Reference", systems: "Systems", property: "Property", when: "Appointment", city: "City", status: "Status", pending: "Awaiting confirmation",
    home: "Back to site", notFound: "We could not find this booking.", loading: "Loading…",
  },
};

export const dict = { ro, en };
